import { render } from "./user-group.vue?vue&type=template&id=591ea7be&scoped=true"
import script from "./user-group.vue?vue&type=script&lang=js"
export * from "./user-group.vue?vue&type=script&lang=js"

import "./user-group.vue?vue&type=style&index=0&id=591ea7be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591ea7be"]])

export default __exports__